export default __webpack_public_path__ + "static/media/ups-sollana.db105e7e.svg";